import React, {useState} from 'react';
import {
    Dialog,
    Flex,
    Title,
    Text,
    Button,
    PriorityIcon
} from '@priority-software/priority-style-react';
import Cookies from 'js-cookie';
import {PromoText, getHardcodedText, MANAGEEOY, EOYWIZARD, eoyPromoCookie} from './consts';
import styles from './EOYPromo.module.scss';
import {isRTL} from '../../../../Localization';
import EOY_EN from '../../../../images/EOY EN.svg';
import EOY_HE from '../../../../images/EOY He.svg';
import {monitorAction} from '../../../../services/datadog';
import {addPromoToBlackList} from '../../actions/reminders';
import {EOYPromoMonitoring} from '../../../../constants/monitoring';
import {
    getUsername,
    startProcWithActivationSource
} from '../../../../_shared/GWTBridge/invoke/genPage';

export const EOYPromo = () => {
    const [isOpen, setIsOpen] = useState(true);

    const handleClose = () => {
        setIsOpen(false);
    };

    const onClose = () => {
        monitorAction(EOYPromoMonitoring.close);
        handleClose();
    };

    const onDefineResponsible = () => {
        monitorAction(EOYPromoMonitoring.link);
        startProcWithActivationSource(MANAGEEOY, 0);
        // No line created in EOY log. If completed owner is change
        handleClose();
    };

    const onReject = () => {
        monitorAction(EOYPromoMonitoring.reject);
        addPromoToBlackList();
        handleClose();
    };

    const onSnooze = () => {
        Cookies.set(eoyPromoCookie, getUsername(), {expires: 1});
        handleClose();
    };

    const onGetStarted = () => {
        monitorAction(EOYPromoMonitoring.start);
        startProcWithActivationSource(EOYWIZARD, 0);
        // New line is created in EOY Log
        handleClose();
    };

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            componentClasses={styles.dialogWrapper}
            content={
                <Flex direction="column" componentClasses={styles.dialogContent}>
                    <Title
                        skin="h2"
                        textColor="primary-700"
                        text={getHardcodedText(PromoText.title)}
                        componentClasses={styles.dialogTitle}
                    />
                    <div className={styles.imageWrapper}>
                        <img src={isRTL() ? EOY_HE : EOY_EN} className={styles.cardImage} />
                    </div>
                    <Flex
                        direction="column"
                        componentClasses={styles.content}
                        alignItems="flex-start"
                    >
                        <Text skin="paragraph-2" textColor="primary-700">
                            {getHardcodedText(PromoText.textP1)}
                        </Text>
                        <Text skin="paragraph-2" textColor="primary-700">
                            <Text skin="paragraph-2" tag="span">
                                {getHardcodedText(PromoText.textP2_start)}
                            </Text>{' '}
                            <a className={styles.link} onClick={onDefineResponsible}>
                                {getHardcodedText(PromoText.textsP2_link)}
                            </a>{' '}
                            <Text skin="paragraph-2" tag="span">
                                {getHardcodedText(PromoText.textP2_end)}
                            </Text>
                        </Text>
                    </Flex>
                    <Flex>
                        <Button skin="text" onClick={onReject}>
                            {getHardcodedText(PromoText.reject)}
                        </Button>
                        <Button skin="text" onClick={onSnooze} prefixIcon={PriorityIcon.newClock}>
                            {getHardcodedText(PromoText.snooze)}
                        </Button>
                        <Button onClick={onGetStarted}>{getHardcodedText(PromoText.start)}</Button>
                    </Flex>
                </Flex>
            }
        />
    );
};
